import { RootState } from "StoreTypes";

export const loginType = (state: RootState) => state.loginTypeService.loginType;

export const isLoginTypeLoading = (state: RootState) =>
  state.loginTypeService.isLoading;
